<template>
    <!-- Componente para mostrar los selects de los servicios de mantenimiento -->
    <div class="price w-9/12 mx-auto lg:flex">
        <div class="form-group mb-5 lg:w-5/12 lg:mr-6">
            <label
                class="text-xs block"
                for="model"
            >Modelo:</label>
            <select
                class="w-full text-base sm:text-lg lg:text-base h-10 appearance-none bg-no-repeat bg-light-brown border-solid border-b border-black"
                :style="`background-image: url('${url}/images/services/appointment/down_arrow_icon.png'); background-size: 0.8rem; background-position: 100%; text-indent: 0;`"
                name="model"
                id="model"
                v-model="model"
            >
                <option
                    value=""
                    disabled
                >-Selecciona un modelo-</option>
                <option
                    v-for="(model, index) in modelsServices"
                    :key="index"
                    :value="index"
                >{{ model.model }}</option>
            </select>
        </div>
        <div class="form-group mb-5 lg:w-5/12 lg:mr-6">
            <label
                class="text-xs block"
                for="km_months"
            >KM / Meses:</label>
            <select
                class="w-full text-base sm:text-lg lg:text-base h-10 appearance-none bg-no-repeat bg-light-brown border-solid border-b border-black"
                :style="`background-image: url('${url}/images/services/appointment/down_arrow_icon.png'); background-size: 0.8rem; background-position: 100%; text-indent: 0;`"
                name="km_months"
                id="km_months"
                v-model="service"
            >
                <option
                    value=""
                    disabled
                >-Selecciona una opción-</option>
                <option
                    v-for="(service, index) in services"
                    :key="index"
                    :value="index"
                >{{ service.name }}</option>
            </select>
        </div>
        <p
            class="w-full lg:w-32 lg:h-10 bg-dark-blue py-1 lg:py-2 text-white text-center text-xl sm:text-2xl lg:text-lg lg:mt-4">
            ${{ formatPrice(servicePrice) }}</p>
    </div>
</template>

<script>
export default {
    props: ['modelsServices'],
    data() {
        return {
            url: $('.url').text(),
            model: '',
            service: '',
        }
    },
    watch: {
        // Observa la variable service para emitir un
        // evento y mostrar los servicios de mantenimiento
        // correspondientes
        service: function (val) {
            this.$eventBus.$emit('service-change', this.modelsServices[this.model].services[val].name)
        }
    },
    methods: {
        // Función para formatear el precio
        formatPrice(price) {
            return parseInt(price).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')
        }
    },
    computed: {
        // Retorna los servicios correspondientes con el modelo
        services() {
            return this.model !== '' ? this.modelsServices[this.model].services : []
        },
        // Retorna el precio correspondiente con el servicio seleccionado
        servicePrice() {
            return this.service !== '' ? this.modelsServices[this.model].services[this.service].price : 0
        }
    },
    created() {
        // Escucha el evento emitido desde el formulario de
        // cita de servicio para cargar los servicios de mantenimiento
        // correspondientes con el modelo en el select
        this.$eventBus.$on('iframe-appointment-message', (data) => {
            // console.log('iframe-appointment-message', data);
            this.model = this.modelsServices.findIndex((model) => model.model === data.modelo)
            this.service = this.modelsServices[this.model].services.findIndex((service) => service.name === data.kilometrosMeses)
        })
    },
    beforeDestroy() {
        this.$eventBus.$off('iframe-appointment-message')
    },
}
</script>

<style>

</style>